import { useTranslation } from "react-i18next"
import CommonUtil from "../../../utils/CommonUtil"
import { useEffect } from "react"

const ChargeInUse = props => {
    const { t } = useTranslation()

    const postTitle = () => {
        if (CommonUtil.isInApp(navigator.userAgent)) {
            window.ReactNativeWebView.postMessage(t('shoot_item4'))
        }
    }

    useEffect(() => {
        postTitle()
    }, [])

    return <div className="App">
        <div style={{ width: '100%' }}>
            <div className="bind-device-faq-marginH25">
                <span style={{ fontSize: 14, color: '#666666', marginTop: 15, lineHeight: '22px' }}>{t('charge_in_use_content')}</span>
            </div>
        </div>
    </div>
}

export default ChargeInUse